<template>
  <div
      class="order-choose-replacement flex flex-auto flex-col">
    <div v-show="false">
      <ShippingEligibilityInfo ref="eligibility" />
    </div>
    <div class="title">
      Choose the replacement item
    </div>
    <div class="description">
      Please select the item you would like to get instead of one you have.
    </div>
    <div style="margin-top: 24px">
      <div class="section-header">
        <div class="flex-1">
          Old Product
        </div>
      </div>
    </div>
    <el-card
        class="item-card replacement-items-view"
        style="margin: 0px !important; min-height: 96px;">
      <div
          class="item-image"
          style="margin: 0px !important;">
        <DeviceImage
            :device="device" />
      </div>
      <div
          class="flex-auto"
          style="margin-left: 8px">
        <div class="flex flex-row">
          <div class="flex-1 text">
            {{ deviceDescription }}
          </div>
        </div>
        <div
            v-if="device.profile && device.profile.color"
            class="colour">
          {{ device.profile.color }}
        </div>
      </div>
    </el-card>
    <div style="margin-top: 24px">
      <div class="section-header">
        <div class="flex-1">
          Best Match
        </div>
      </div>
    </div>
    <div
        v-if="bestMatchFound === false"
        style=" display: flex; padding: 16px 24px; ">
      <div
          class="errormsg"
          style="width: 987px; display: flex; align-items: center; justify-content: center;height: 84px;border: 1px solid var(--tertiary-500, #DEE5EC); color: var(--tertiary-700, #81919F);font-feature-settings: 'clig' off, 'liga' off;">
        All the matching devices are out of stock or have shipping restrictions. Please contact your supervisor for assistance.
      </div>
    </div>

    <div
        v-else
        v-loading="bestMatch.ux_properties.loading">
      <el-card
          class="item-card replacement-items-view"
          style="margin: 0px !important; min-height: 96px; ">
        <div
            v-if="!bestMatch.shipping_eligible"
            class="flex flex-row"
            style="position: absolute; right: 0">
          <span
              v-if="expedited"
              class="expedited">Expedited</span>
          <span
              class="shipping-restrictions-label">Shipping Restrictions Apply</span>
        </div>
        <div
            class="item-image"
            style="margin: 0px !important;">
          <DeviceImage
              :device="bestMatch" />
        </div>
        <div
            class="flex-auto"
            style="margin-left: 8px">
          <div class="flex flex-row">
            <div class="flex-1 text">
              {{ bestMatch.product.description }} - Stock {{ bestMatch.stock }}
            </div>
          </div>
          <div class="colour">
            {{ bestMatch.color }}
          </div>
          <div
              v-if="bestMatch.estimated_delivery"
              class="estimated-delivery">
            {{ bestMatch.estimated_delivery }}
          </div>
          <div
              v-if="bestMatch.out_of_stock"
              class="device-status"
              style="align-self: flex-end">
            Out of Stock
          </div>
        </div>
      </el-card>
    </div>
    <div
        v-if="isSupervisor"
        style="padding-top: 8px; padding-bottom: 8px;">
      The new product is determined by the best match algorithm.
    </div>
    <div
        v-if="anyReplacementAvailable"
        style="display: flex;padding-top: 24px;align-items: center;">
      <a
          v-if="!showReplacementOptions"
          class="showtext"
          @click="showOptions()">
        Show Other Options
      </a>
      <a
          v-if="showReplacementOptions"
          class="showtext"
          @click="hideOptions()">
        Hide Other Options
      </a>
    </div>
    <div
        v-if="showReplacementOptions"
        class="frame">
      <div
          class=""
          style="padding-top: 8px; margin-bottom: 8px;">
        <el-input
            v-model="searchValue"
            type="text"
            placeholder="Search"
            class="searchbox"
            clearable
            @clear="setSelectedOptionAsBestMatch" />
        <div
            v-if="noResultFound"
            style=" display: flex; padding: 16px 24px; ">
          <div
              class="errormsg"
              style="width: 987px; display: flex; align-items: center; justify-content: center;height: 84px;border: 1px solid var(--tertiary-500, #DEE5EC); color: var(--tertiary-700, #81919F);font-feature-settings: 'clig' off, 'liga' off;">
            No devices matching your search request found. Please try another one.
          </div>
        </div>
      </div>
      <div style="overflow-y: scroll; height: 60vh;">
        <div
            v-for="item in matchingReplacements"
            :key="item.id">
          <div
              v-loading="item.ux_properties.loading"
              class="replacement-options-items-view">
            <el-card
                class="item-card"
                :class="{'highlighted-item-card' : isItemSelected(item) }">
              <div
                  v-if="!item.shipping_eligible"
                  style="position: absolute; right: 4rem">
                <span
                    v-if="expedited"
                    class="expedited item">Expedited</span>
                <span class="shipping-restrictions-label item">Shipping Restrictions Apply</span>
              </div>
              <div
                  class="item-image"
                  style="margin: 0px !important;">
                <DeviceImage
                    :device="item" />
              </div>
              <div
                  style="margin-left: 8px"
                  class="flex-auto">
                <div class="flex flex-row">
                  <div class="item-name flex-1">
                    {{ item.product.description }} - Stock {{ item.stock }}
                  </div>
                </div>
                <div
                    v-if="item.color"
                    class="item-sku">
                  {{ item.color | capitalize }}
                </div>
                <div
                    v-if="item.estimated_delivery"
                    class="estimated-delivery">
                  {{ item.estimated_delivery }}
                </div>
                <div
                    v-if="item.out_of_stock"
                    class="device-status"
                    style="align-self: flex-end">
                  Out of Stock
                </div>
              </div>
              <input
                  v-model="selectedOption"
                  type="radio"
                  name="options"
                  :value="item.id"
                  class="radio"
                  :disabled="item.shipping_eligible === false"
                  style="margin-right: 16px; border-radius: 4px; width: 24px; height: 24px; align-self: center; accent-color: #1998D5;"
                  @change="toggleSelection(item)">
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DeviceImage from "@/components/Shared/DeviceImage.vue";
import { isEmpty } from "lodash";
import ShippingEligibilityInfo from "@/containers/CustomerRequest/CustomerRequestComponents/ShippingEligibilityInfo";

export default {
  name: "ChooseReplacement",
  components: { ShippingEligibilityInfo, DeviceImage },
  props: {
    isSupervisor: {
      type: Boolean,
      default: false,
    },
    expedited: {
      type: Boolean,
      default: false,
    },
    country: {
      type: String,
      required: true,
    },
    state: {
      type: String,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
    skus: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    selectedValue: {
      type: Object,
      required: true,
    },
    bestMatch: {
      type: Object,
      required: true,
    },
    replacementSearch: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      showReplacementOptions: this.replacementSearch !== "",
      isOptionSelected: false,
      selectedOption:
        this.selectedValue && this.selectedValue.id ? this.selectedValue.id : 0,
      searchValue: this.replacementSearch,
      nonShippableProducts: [],
    };
  },
  computed: {
    deviceDescription() {
      return this.device.name;
    },
    anyReplacementAvailable() {
      return this.availableReplacements.length > 0;
    },
    availableReplacements() {
      let selection = this.bestMatch;
      return this.skus.filter(function (item) {
        return item.id !== selection.id;
      });
    },
    bestMatchFound() {
      return !isEmpty(this.bestMatch);
    },
    noResultFound() {
      return (
        this.searchValue.length > 0 && this.matchingReplacements.length === 0
      );
    },
    matchingReplacements() {
      if (!this.searchValue.length) {
        return this.availableReplacements;
      } else {
        return this.availableReplacements.filter(
          (item) =>
            item.type.toLowerCase().includes(this.searchValue.toLowerCase()) ||
            item.product.description
              .toLowerCase()
              .includes(this.searchValue.toLowerCase())
        );
      }
    },
  },
  watch: {
    searchValue: {
      handler() {
        this.$emit("set-replacement-search", this.searchValue);
      },
    },
  },
  mounted() {
    this.productShippingEligibility(this.selectedValue);
  },
  updated() {
    if (this.selectedValue) {
      this.selectedOption = this.selectedValue.id;
    }
  },
  methods: {
    isItemSelected(item) {
      return item.id === this.selectedOption;
    },
    toggleSelection(item) {
      this.productShippingEligibility(item, () => {
        this.$emit("set-selected-options", item);
      });
    },
    showOptions() {
      this.showReplacementOptions = true;
    },
    hideOptions() {
      this.showReplacementOptions = false;
      this.setSelectedOptionAsBestMatch();
    },
    setSelectedOptionAsBestMatch() {
      this.searchValue = "";
      this.selectedOption = 0;
      this.$emit("set-selected-options", this.bestMatch);
    },
    productShippingEligibility: function (item, callback) {
      callback = callback || (() => {});

      const { product } = item;
      const { kind } = product;

      if (isEmpty(kind)) return;

      const { country, state } = this;
      this.$set(item.ux_properties, "loading", true);
      this.$refs.eligibility
        .evaluate({
          product_kinds: [kind],
          country_code: country,
          state_code: state,
          expedited: this.expedited,
        })
        .then((isEligible) => {
          this.$set(item, "shipping_eligible", isEligible);
          this.skus
            .filter((e) => e.type === kind)
            .forEach((e) => this.$set(e, "shipping_eligible", isEligible));

          if (!isEligible) {
            this.$notify({
              title: "Warning",
              message: `${
                this.expedited ? "Expedited " : ""
              }Shipping Restrictions Apply!`,
              type: "warning",
              duration: 6000,
            });
          }
          callback(item);
        })
        .finally(() => {
          this.$set(item.ux_properties, "loading", false);
        });
    },
  },
};
</script>

<style lang="scss">
.order-choose-replacement {
  .el-card.is-always-shadow {
    box-shadow: none !important;
  }
  gap: 8px;
  .showtext {
    color: var(--light-primary-textlink-base, #1476ad);
    font-feature-settings: "clig" off, "liga" off;

    /* textlink (inline) /normal-medium */
    font-family: Equip;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 171.429% */
    text-decoration-line: underline;
  }
  .searchbox {
    display: flex;
    width: 375px;
    padding: 12px 60px;
    background: white url("../../../assets/find.svg") no-repeat 16px;
    background-size: 25px 25px;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid var(--light-tertiary-border-deep, #81919f);
  }
  .searchbox:focus-within {
    border: 1px solid #1998d5;
  }
  .searchbox input {
    border: none;
  }
  .searchbox img {
    position: absolute;
    top: 2px;
    right: 5px;
    width: 10px;
    height: 10px;
  }
  .searchbox.el-input {
    width: 245px !important;
    height: 22px !important;
  }
  input.el-input__inner {
    width: 263px !important;
    height: 24px !important;
    padding: 0px !important;
  }

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }
  .device-status {
    color: #f1670d;
    font-size: 14px;
    font-weight: 400;
    padding-top: 5px;
  }
  .estimated-delivery {
    color: var(--light-content-backup, #6e6e6e);
    font-family: Equip;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .replacement-items-view {
    padding: 0px !important;
    margin: 0px !important;
    box-shadow: none !important;
    align-items: stretch;
    el-card {
      width: 988px !important;
      box-shadow: none !important;
    }
    .colour {
      gap: 2px;
      color: var(--light-content-backup, #6e6e6e);
      font-feature-settings: "clig" off, "liga" off;

      /* body/normal-regular */
      font-family: Equip;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 171.429% */
    }
    .text {
      gap: 2px;
      color: var(--light-content-base, #424242);
      font-family: Equip;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      height: 24px;
      padding-top: 16px;
      padding-bottom: 8px;
    }
    .item-image {
      height: 80px;
      width: 80px;
      padding: 8px 4px 8px 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .item-name {
      padding: 8px 24px 8px 4px;
      margin: 10px 0px 0px 0px !important;
      height: 80px;
      align-self: flex-end;
      display: flex;
      color: var(--light-content-base, #424242);

      /* body/large-medium */
      font-family: Equip;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }

  div.el-card__body {
    margin: 0px !important;
    weight: 10px !important;
    display: flex !important;
    position: relative;

    .shipping-restrictions-label {
      display: inline-block;
      background-color: #fdf6ec;
      color: #ff8c00;
      font-size: 0.8em;
      padding: 3px 10px;
      border-radius: 3px;
      border: 1px solid #faecd8;
      margin: 1rem 1rem 1rem 0.5rem;
      &.item {
        margin: 0;
      }
    }

    .expedited {
      @extend .shipping-restrictions-label;
      color: $--color-primary;
      background-color: lighten($--color-primary, 50%);
      margin: 1rem 0 1rem;
    }
  }
  .replacement-options-items-view {
    .item-card {
      padding: 8px;
      margin-right: 0px !important;
      height: 90px;
      box-shadow: none !important;
    }
    img,
    .item-image {
      margin-top: 5px;
      height: 80px !important;
      width: 80px !important;
    }
    .highlighted-item-card {
      background: #eff8fc;
      border: 2px solid #1998d5;
      border-radius: 4px;
    }
  }
}
</style>
